import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import "./DriverdetailPage.css";
import secured from "../../../../assets/secured.png";
import price_icon from "../../../../assets/price_icon.svg";
import { connect } from "react-redux";
import { formatPhoneNumber } from "../../../comman/components/TimeSence";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import profileDefault from "../../../../assets/profile_default.png";
import { useTranslation } from "react-i18next";
import { postRequestcall } from "../../../comman/util/postRequest";
import { BOOKING, SENDBOOK_NOTIFICATION } from "../../../constants/apiurl";
import { Timeformat24hours } from "../../../comman/components/Datetimeformat";
import FormgroupPage, { FormLabel } from "../../../comman/formgroup/FormgroupPage";
import { fetchHeaderContent } from "../../../seoroute/redux/actions";
import moment from "moment";

function DriverdetailPage(props) {

  const { t } = useTranslation();
  let getId = window.location.pathname.split("/").pop();
  const [driverdetail, setDriverdetail] = useState({});
  const [bookinginfo, setBookinginfo] = useState({
    first_name: "",
    last_name: "",
    comments: "",
  });
  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
  });
  const navigate = useNavigate();
  // const nameRegex = /^[A-Za-z ığüşöçİĞÜŞÖÇ]+$/;

  // eslint-disable-next-line
  useEffect(() => {
    getDriverdetail();
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  useEffect(() => {
    props?.fetchHeaderContent(t("pages.meta.cabBook.title"), t("pages.meta.cabBook.description"), "");
    // eslint-disable-next-line
  }, [props?.language]);

  const getDriverdetail = () => {
    let getDriver = props?.vehiclelist?.data?.filter((item) => item.id === getId);
    setDriverdetail(getDriver[0]);
  };

  const validation = () => {
    let value = true;
    // if (!nameRegex.test(bookinginfo.first_name)) {
    //   errors.first_name = "pages.signup.fullname_validation";
    //   value = false;
    // }
    // if (!nameRegex.test(bookinginfo.last_name)) {
    //   errors.last_name = "pages.signup.fullname_validation";
    //   value = false;
    // }
    if(!bookinginfo.first_name.trim()) {
      errors.first_name = "pages.driver_detail.first_place";
      value = false;
    }
    if (!bookinginfo.last_name.trim()) {
      errors.last_name = "pages.driver_detail.last_place";
      value = false;
    }
    if (bookinginfo.first_name === "") {
      errors.first_name = "pages.driver_detail.first_place";
      value = false;
    }
    if (bookinginfo.last_name === "") {
      errors.last_name = "pages.driver_detail.last_place";
      value = false;
    }
    setErrors({
      ...errors,
      first_name: errors.first_name,
      last_name: errors.last_name,
    });
    return value;
  };

  const detailOnchange = (e) => {
    setBookinginfo({
      ...bookinginfo,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const submitCab = async (e) => {
    e.preventDefault();
    if (validation()) {
      let type = "";
      let return_date = "";
      let return_time = "";
      return_date = props?.waytype?.id === 2 ? moment(props?.returndate_time).format("YYYY-MM-DD") : "";
      return_time = props?.waytype?.id === 2 ? Timeformat24hours(props?.returndate_time) : "";
      switch (props?.waytype?.id) {
        case 1:
          type = "one way"
          break;
        case 2:
          type = "round trip"
          break;
        case 3:
          type = "airport"
          break;
        default:
          break;
      }
      let geturl = BOOKING + `?vehicle_id=${driverdetail?.vid}&first_name=${bookinginfo?.first_name
        }&country_code=${props?.logindata?.country_code}&mobile_number=${props?.logindata?.mobile
        }&pick_up_address=${props?.pickup?.from_place}&drop_address=${props?.destination?.to_place
        }&date=${moment(props?.pickupdate_time).format("YYYY-MM-DD")}
         &time=${Timeformat24hours(props?.pickupdate_time)}&email=${props?.logindata?.email
        }&last_name=${bookinginfo?.last_name}&kilometer=${props?.destination?.kilometer
        }&booking_type=${type}&return_date=${return_date
        }&return_time=${return_time}&comment=${bookinginfo?.comments}&lang=${props?.language?.toLowerCase()}`;
      let bookingResponse = await postRequestcall(geturl,props?.access_token,"");
      if (bookingResponse?.status === 200) {
        let getMessage = await bookingResponse.json();
        await callSendBookingNotification(getMessage?.data?.booking_id);
        toast.success(getMessage.msg);
        navigate("/");
        // let getUrl = SENDBOOK_NOTIFICATION + `?booking_id=${getMessage?.data?.booking_id}&lang=${props?.language?.toLowerCase()}`
        // await postRequestcall(getUrl,props?.access_token,"");
      } else if (bookingResponse?.status === 400) {
        let getError = await bookingResponse?.json();
        if (getError?.error?.is_deleted) {
          toast.error(getError?.errors);
        } else {
          toast.error(getError?.errors);
        }
      } else if (bookingResponse?.status === 500) {
          toast.error("Something went wrong");
      }
    }
  };

  const callSendBookingNotification = async (id) =>{
    let getUrl = SENDBOOK_NOTIFICATION + `?booking_id=${id}&lang=${props?.language?.toLowerCase()}`
        await postRequestcall(getUrl,props?.access_token,"");
  }
  return (
    <>
      <div className="driver-detail">
        <Container>
          <Row>
            <Col sm={12} md={12} lg={5} xl={5}>
              <div className="driver pb-4">
                <Container>
                  <Row>
                    <div className="col-12">
                      <h5 className="heading">
                        {t("pages.driver_detail.details")}
                      </h5>
                    </div>
                    <div className="col-4">
                      <img
                        src={
                          driverdetail?.user_profile_image === null
                            ? profileDefault
                            : driverdetail?.user_profile_image
                        }
                        alt="user profile"
                      ></img>
                    </div>
                    <div className="col-8">
                      <img src={secured} className={"secured_img"} alt="secure"></img>
                    </div>
                    <div className="col-6 mt-2 mb-1">
                      <FormLabel className={"w-100 mb-0"} require={false} label={t("pages.driver_detail.driver_name")} />
                      <p className="mb-0">{driverdetail?.driver_name}</p>
                    </div>
                    <div className="col-6  mt-2 mb-1">
                      <FormLabel className={"mb-0"} require={false} label={t("pages.driver_detail.driver_mob")} />
                      <Form.Text>
                        {driverdetail?.country_code +
                          " " +
                          formatPhoneNumber(driverdetail?.contact)}
                      </Form.Text>
                    </div>
                    <div className="col-6 mt-2 mb-1">
                      <FormLabel className={"w-100 mb-0"} require={false} label={t("pages.driver_detail.car_details")} />
                      <p className="mb-0">
                        {driverdetail?.vehicle_type_details?.car_model
                          .charAt(0)
                          .toUpperCase() +
                          driverdetail?.vehicle_type_details?.car_model.slice(
                            1
                          )}
                      </p>
                    </div>
                    <div className="col-6 mt-2 mb-1">
                      <FormLabel className={"w-100 mb-0"} require={false} label={t("pages.driver_detail.total_seats")} />
                      <Form.Text>{driverdetail?.number_of_seats}</Form.Text>
                    </div>
                    <div className="col-12 mt-2 mb-1">
                      <FormLabel className={"w-100 mb-0"} require={false} label={t("pages.myrides.pickup_location")} />
                      <p className="mb-0">{props?.pickup?.from_place}</p>
                    </div>
                    <div className="col-12 mt-2 mb-1">
                      <FormLabel className={"w-100 mb-0"} require={false} label={t("pages.myrides.destination_location")} />
                      <p className="mb-0">{props?.destination?.to_place}</p>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="price-banner">
                        <img src={price_icon} alt="price"></img>
                        <div className="ps-2">
                          <FormLabel className={"w-100 mb-0"} require={false} label={t("pages.myrides.price")} />
                          <Form.Text>
                            {driverdetail?.price_to_display}{" "}{process.env.REACT_APP_CURRENCY_SYMBOL}
                            {/* {(
                              props?.destination?.kilometer *
                              driverdetail?.vehicle_type_details?.kilometer_wise_price
                            ).toFixed(2)}{" "}{process.env.REACT_APP_CURRENCY_SYMBOL} */}
                          </Form.Text>
                        </div>
                      </div>
                    </div>
                  </Row>
                </Container>
              </div>
            </Col>
            <div className="col-sm-12 col-md-12 col-lg-7 col-xl-7">
              <div className="customer-info pb-4">
                <Container>
                  <Row>
                    <div className="col-12">
                      <h5>{t("pages.driver_detail.contact")}</h5>
                    </div>
                    <div className="col-12">
                      <FormgroupPage label={t("pages.driver_detail.first_name")} placeholder={t("pages.driver_detail.first_place")} value={bookinginfo.first_name} name={"first_name"}
                        onChange={detailOnchange} error={t(errors.first_name)} />
                    </div>
                    <div className="col-12 mt-2">
                      <FormgroupPage label={t("pages.driver_detail.last_name")} placeholder={t("pages.driver_detail.last_place")} value={bookinginfo?.last_name} name={"last_name"}
                        onChange={detailOnchange} error={t(errors?.last_name)} />
                    </div>
                    <div className="col-12 mt-2">
                      <FormgroupPage label={t("pages.driver_detail.email")} placeholder={t("pages.driver_detail.email_place")} value={props?.logindata?.email} name={"email_address"}
                        onChange={detailOnchange} disabled={true} error={""} />
                    </div>
                    <div className="col-12 mt-2">
                      <FormgroupPage label={t("pages.driver_detail.mobile")} placeholder={t("pages.driver_detail.mobile_place")} value={props?.logindata?.country_code + " " + formatPhoneNumber(props?.logindata?.mobile)} name={"mobile_number"}
                        onChange={detailOnchange} disabled={true} error={""} />
                    </div>
                    <div className="col-12 mt-2">
                      <FormgroupPage as={"textarea"} require={false} style={{ height: "auto" }} rows={2} label={t("pages.driver_detail.comments")} placeholder={t("pages.driver_detail.comment_place")}
                        value={bookinginfo?.comments} name={"comments"} onChange={detailOnchange} />
                    </div>
                  </Row>
                </Container>
              </div>
              <button
                type="submit"
                style={{
                  lineHeight: "2",
                  fontFamily: "amazon_embermedium",
                }}
                className="btn-submit hover-btn w-100 mt-4"
                onClick={(e) => submitCab(e)}
              >
                {t("pages.Submit")}
              </button>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  vehiclelist: state?.home?.vehiclelist,
  pickup: state?.home?.pickup,
  destination: state?.home?.destination,
  pickupdate_time: state?.home?.pickupdate_time,
  returndate_time: state?.home?.returndate_time,
  logindata: state?.login?.logindata,
  waytype: state?.home?.waytype,
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchHeaderContent })(DriverdetailPage);
